export default __webpack_public_path__ + "static/media/iic 8.f4c9ad1e.JPG";